module.exports = __webpack_public_path__ + "img/vnpt.dbfa5c3f.png";